import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./AdminShell.scss";

/**
 * Tabs of the super_admin admin area. Unlike the LPI/CPI tab bars — whose tabs
 * are `?tab=` states of one page — each of these is its own route, so that
 * /admin/media keeps the URL it has always had and can stay bookmarked.
 */
const TABS = [
  { path: "/admin/media", labelKey: "admin.tab.media" },
  { path: "/admin/release-notes", labelKey: "admin.tab.releaseNotes" },
  { path: "/admin/deletions", labelKey: "admin.tab.deletions" },
  { path: "/admin/tenants", labelKey: "admin.tab.tenants" },
] as const;

/**
 * Shell for the super_admin-only admin area: a tab bar plus whichever admin
 * page the route resolved to. Deliberately kept out of the main nav (see
 * MainMenu) — the whole area is reachable by direct URL only.
 */
const AdminShell: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="container admin-shell">
      <div className="admin-shell__tab-bar">
        {TABS.map((tab) => (
          <button
            key={tab.path}
            type="button"
            className={`admin-shell__tab ${
              pathname === tab.path ? "admin-shell__tab--active" : ""
            }`}
            onClick={() => navigate(tab.path)}
          >
            {t(tab.labelKey)}
          </button>
        ))}
      </div>
      <Outlet />
    </div>
  );
};

export default AdminShell;
